import { render } from "./DeansListModal.vue?vue&type=template&id=027fbb82&scoped=true"
import script from "./DeansListModal.vue?vue&type=script&lang=js"
export * from "./DeansListModal.vue?vue&type=script&lang=js"

import "./DeansListModal.vue?vue&type=style&index=0&id=027fbb82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027fbb82"]])

export default __exports__